import { Role, User, UserRole } from "@/common/types";
import { createSlice } from "@reduxjs/toolkit";

interface UserState {
  user: Pick<User, "id" | "name" | "email" | "roles" | "companyId"> | null;
}

const initialState: UserState = {
  user: {
    id: "",
    name: "",
    email: "",
    companyId: "",
    roles: [{ role: UserRole.WORKER as unknown as Role }],
  },
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    resetUser: (state) => {
      state.user = null;
    },
  },
});

export const { resetUser } = userSlice.actions;
export default userSlice.reducer;
